// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const ro: KnowledgePagesCopy = {
  knowledgePage: 'Pagină de cunoștințe',
  knowledgePages: 'Pagini de cunoștințe',
  featureOffTitle: 'Paginile de cunoștințe nu sunt activate în acest spațiu de lucru.',
  featureOffBody: 'Contextul companiei și sursele sunt în continuare în Cunoștințe.',
  loadingPage: 'Se încarcă pagina…',
  loadingSuggestion: 'Se încarcă propunerea…',
  cancel: 'Anulează',
  tryAgain: 'Încercați din nou',
  everyoneIn: 'Toată lumea din {company}',
  yourCompany: 'compania dumneavoastră',
  revision: 'Revizia {n}',
  openRevision: 'Deschide revizia {n}',
  pageCount: 'one:pagină|few:pagini|other:de pagini',
  topicCount: 'one:subiect|few:subiecte|other:de subiecte',
  sectionCount: 'one:secțiune|few:secțiuni|other:de secțiuni',
  lineCount: 'one:rând|few:rânduri|other:de rânduri',
  documentCount: 'one:document|few:documente|other:de documente',
  changeCount: 'one:modificare|few:modificări|other:de modificări',
  newPageCount: 'one:pagină nouă|few:pagini noi|other:de pagini noi',
  changedPageCount: 'one:pagină modificată|few:pagini modificate|other:de pagini modificate',
  otherSectionCount: 'one:altă secțiune|few:alte secțiuni|other:de alte secțiuni',
  characterCount: 'one:caracter|few:caractere|other:de caractere',
  diffStats: 'Modificate: {sections} · adăugate: {added} · eliminate: {removed}',
  diffMatchesBase: 'Textul propus este identic cu revizia de bază.',
  diffIntroduction: 'Introducere',
  diffOtherUnchanged: '{sections} fără modificări.',
  timeJustNow: 'chiar acum',
  originImportedFrom: 'Importat din {path}',
  originImportedFromCommit: 'Importat din {path} @ {commit}',
  authorityApprovedInPoneva: 'Aprobat în Poneva',
  authorityImported: 'Importat',
  authorityInRepository: '{canonicality} în depozit',
  authorityVerified: 'verificat {date}',
  authorRepositoryImport: 'Import din depozit',
  authorSuggestedInChat: 'Propus în chat',
  authorSuggestedInChatWith: 'Propus în chat cu {name}',
  authorSuggestedBy: 'Propus de {name}',
  authorSuggestedByApp: 'Propus de o aplicație conectată',
  authorSuggestedByColleague: 'Propus de un coleg',
  authorSuggestedByYou: 'Propus de dumneavoastră',
  authorSuggestedOnBehalf: 'Propus de {app} în numele lui {name}',
  authorSuggestedByAppOnBehalf: 'Propus de o aplicație conectată în numele lui {name}',
  authorSuggestedAndApproved: 'Propus și aprobat de {name}',
  approverApprovedBy: 'aprobat de {name}',
  approverAppliedBy: 'aplicat de {name}',
  kindCreatePage: 'Pagină nouă',
  kindUpdatePage: 'Actualizare propusă',
  kindArchivePage: 'Arhivare',
  statusConflict: 'Conflict · pagina s-a modificat',
  statusPending: 'În așteptarea verificării',
  statusApproved: 'Aprobat',
  statusRejected: 'Respins',
  statusWithdrawn: 'Retras',
  statusSuperseded: 'Înlocuit',
  errRevisionConflict: 'Această pagină s-a modificat în timp ce o verificați.',
  errProposalChanged:
    'Această propunere s-a modificat în timp ce o verificați. Verificați cea mai recentă versiune înainte de a decide.',
  errPublishRequired:
    'Doar publicatorii din companie pot aproba modificări ale cunoștințelor sau importa pagini.',
  errProposalLimit:
    'Compania dumneavoastră are deja 200 de propuneri care așteaptă verificarea. Verificați câteva înainte de a propune altele.',
  errAuthorLimit:
    'Aveți deja 50 de propuneri care așteaptă verificarea. Așteptați până se decide asupra unora sau retrageți câteva înainte de a propune altele.',
  errImportProposalLimit:
    'Acest import ar adăuga mai multe pagini modificate de verificat decât încap în coada de verificare a companiei (cel mult 200). Decideți asupra unor propuneri din De verificat, apoi aplicați din nou.',
  errImportChanged:
    'Acesta nu este importul pe care l-ați verificat. Deschideți-l din nou și verificați-l înainte de a-l aplica.',
  errImportItemNotFound: 'Acest document nu mai face parte din import.',
  errIdempotencyConflict:
    'Această propunere a fost deja trimisă cu alt conținut. Reîncărcați și încercați din nou.',
  errImportHashMismatch:
    'Un fișier din acest snapshot nu corespunde sumei de control înregistrate. Creați un snapshot nou și încercați din nou.',
  errImportAlreadyApplied: 'Acest import a fost deja aplicat.',
  errImportDiscarded: 'Acest import a fost abandonat. Alegeți din nou fișierul snapshot.',
  errImportDuplicateItem:
    'Acest snapshot conține același document de două ori. Creați din nou snapshotul.',
  errInvalidImport:
    'Poneva nu a putut accepta acest snapshot. Creați unul nou cu scriptul de snapshot și încercați din nou.',
  errInvalidInput:
    'Poneva nu a putut accepta aceste date. Verificați câmpurile și încercați din nou.',
  errImportLimit:
    'Prea multe importuri sunt pregătite, dar neaplicate. Aplicați sau abandonați câteva înainte de a pregăti altul.',
  errPageTooLarge: 'O pagină depășește 256 KB. Împărțiți-o în pagini mai mici.',
  errTooManySections: 'O pagină are peste 2.000 de titluri. Împărțiți-o în pagini mai mici.',
  errPageLimit: 'Compania dumneavoastră a atins limita de 2.000 de pagini de cunoștințe.',
  errCollectionLimit: 'Compania dumneavoastră a atins limita de 100 de subiecte.',
  errProposalNotPending:
    'S-a decis deja asupra acestei propuneri. Starea afișată este cea actuală.',
  errRequesterRemoved:
    'Persoana care a propus aceasta nu mai face parte din companie, așa că propunerea nu poate fi aprobată.',
  errRevisionAlreadyCurrent: 'Această revizie este deja cea actuală.',
  errPageArchived:
    'Această pagină a fost arhivată în timp ce o verificați. Verificați din nou propunerea înainte de a decide.',
  errAlreadyArchived: 'Această pagină este deja arhivată.',
  errProposalForbidden: 'Doar persoana care a făcut propunerea o poate retrage.',
  errUnavailable: 'Paginile de cunoștințe nu sunt disponibile momentan.',
  errTimeout: 'Poneva a răspuns prea greu.',
  errItemTooLarge: '{path} depășește 256 KB. Împărțiți-l în pagini mai mici.',
  errItemTooManySections: '{path} are peste 2.000 de titluri. Împărțiți-l în pagini mai mici.',
  errItemHashMismatch:
    '{path} nu corespunde sumei de control înregistrate. Creați un snapshot nou și încercați din nou.',
  errNoLongerAvailable: 'Acest element nu vă mai este disponibil.',
  errTooLargeToSend: 'Acest fișier este prea mare pentru a fi trimis.',
  cardChecking: 'Se verifică starea…',
  cardNotAvailable: 'Indisponibil',
  cardStatusUnavailable: 'Stare indisponibilă',
  cardUnshowable: 'Această actualizare de cunoștințe propusă nu a putut fi afișată.',
  cardEyebrow: 'Actualizare de cunoștințe propusă',
  cardLabel: 'Actualizare de cunoștințe propusă · {title}',
  cardMissing: 'Această propunere nu vă mai este disponibilă.',
  cardUnknown:
    'Nu am putut verifica stadiul acestei propuneri. Deschideți verificarea pentru a-i vedea starea.',
  cardCheckAgain: 'Verifică din nou',
  cardReview: 'Verifică actualizarea',
  statusLineApproved: 'Cunoștințe aprobate',
  readyCount: 'one:gata pentru căutare|few:gata pentru căutare|other:gata pentru căutare',
  preparingCount: 'one:în pregătire|few:în pregătire|other:în pregătire',
  attentionCount: 'one:necesită atenție|few:necesită atenție|other:necesită atenție',
  topicsExplore: 'Explorați un subiect',
  topicsAllPages: 'Toate paginile',
  topicsOpenPages: 'Deschide Pagini',
  topicsEmpty:
    'Nu există încă pagini aprobate. Paginile conțin cunoștințe detaliate despre companie, cu întregul istoric al reviziilor.',
  reviewsTitle: 'Actualizări de pagini propuse',
  reviewsTitleMine: 'Actualizările de pagini propuse de dumneavoastră',
  reviewsIntro:
    'Fiecare propunere este o revizie candidată completă, cu motivul și dovezile ei. Nimic nu se modifică până nu aprobați exact acea revizie.',
  reviewsIntroMine:
    'Propunerile dumneavoastră așteaptă aici până când un publicator din companie le verifică. Până atunci, paginile rămân neschimbate.',
  loadPagesFailed: 'Nu am putut încărca paginile de cunoștințe.',
  loadProposalsFailed: 'Nu am putut încărca actualizările de pagini propuse.',
  loadMoreFailed: 'Nu am putut încărca mai multe pagini.',
  otherPages: 'Alte pagini',
  loadTopicFailed: 'Nu am putut încărca acest subiect.',
  revisionShort: 'r{n}',
  updatedOn: 'Actualizat {date}',
  emptyTitle: 'Nu există încă pagini de cunoștințe.',
  emptyBody:
    'Paginile conțin cunoștințele aprobate și detaliate ale companiei dumneavoastră — direcție, decizii și moduri de lucru — cu fiecare revizie păstrată. Importați dintr-un snapshot al depozitului sau începeți o pagină în chat; un publicator aprobă fiecare pagină înainte ca aceasta să devină cunoștințe ale companiei.',
  importFromSnapshot: 'Importă dintr-un snapshot al depozitului',
  startInChat: 'Începe o pagină în chat',
  startInChatPrompt:
    'Ajută-mă să încep o pagină de cunoștințe pentru compania noastră. Întreabă-mă ce ar trebui să cuprindă și nu inventa conținut. Rămâne o propunere până când un publicator din companie o aprobă.',
  loadingPages: 'Se încarcă paginile de cunoștințe…',
  filterLabel: 'Filtrați paginile după titlu',
  filterPlaceholder: 'Filtrați paginile',
  importButton: 'Importă',
  showingTopic: 'Se afișează {topic}',
  showAllTopics: 'Afișează toate subiectele',
  loadingTopic: 'Se încarcă acest subiect…',
  noMatch: 'Nicio pagină nu corespunde cu „{filter}”.',
  topicNoPages: 'Nu există încă pagini aprobate în acest subiect.',
  loading: 'Se încarcă…',
  loadMore: 'Încarcă mai multe pagini',
  metaApproved: 'aprobat {date}',
  metaRepositoryAuthoritative: 'depozitul rămâne sursa de referință',
  loadPageFailed: 'Nu am putut încărca această pagină.',
  loadHistoryFailed: 'Nu am putut încărca istoricul reviziilor.',
  outlineLabel: 'Secțiunile paginii',
  outlineToggle: 'Pe această pagină',
  loadingHistory: 'Se încarcă istoricul reviziilor…',
  historyLabel: 'Istoricul reviziilor',
  historyIntro:
    'Fiecare revizie aprobată este păstrată. Restaurarea unei revizii anterioare creează o propunere de verificat; nu șterge niciodată reviziile ulterioare.',
  historyCurrent: 'Actuală',
  historyViewing: 'Afișată',
  historyView: 'Vezi',
  historyViewAria: 'Vezi revizia {n}',
  restoreAria: 'Restaurează ca propunere: revizia {n}',
  restoreCreating: 'Se creează propunerea…',
  restore: 'Restaurează ca propunere',
  restoreUnconfirmed:
    'Nu am putut confirma că propunerea a fost creată. Verificați De verificat înainte de a încerca din nou.',
  editTooLarge:
    'Această pagină depășește 256 KB. Împărțiți-o în pagini mai mici înainte de a o propune.',
  editConflict:
    'Această pagină s-a modificat în timp ce o editați. Copiați textul, deschideți cea mai recentă revizie și propuneți din nou modificarea.',
  editUnconfirmed:
    'Nu am putut confirma că propunerea dumneavoastră a fost trimisă. Verificați De verificat înainte de a o trimite din nou.',
  editHeading: 'Propuneți o modificare',
  editIntro:
    'Editați revizia {n}. Un publicator din companie verifică exact această modificare înainte să devină revizia {next}; până atunci, pagina rămâne neschimbată.',
  editOutdated:
    'O revizie mai nouă a fost aprobată în timp ce editați. Copiați textul, apoi reluați de la cea mai recentă revizie, ca să nu se piardă nimic din ce s-a modificat în ea.',
  editContentLabel: 'Conținutul paginii (Markdown)',
  editReasonLabel: 'De ce această modificare?',
  editReasonPlaceholder: 'Ce s-a schimbat și de unde provine informația.',
  editSending: 'Se trimite…',
  editSend: 'Trimite spre verificare',
  editDiscardConfirm:
    'Renunțați la această modificare? Nimic din ce ați schimbat nu a fost trimis.',
  editNoChanges: 'Nicio modificare încă.',
  editNeedsContent: 'O pagină trebuie să aibă conținut.',
  exportFailed: 'Nu am putut exporta această pagină. Încercați din nou.',
  askPagePrompt: 'Întrebare despre pagina de cunoștințe „{title}” (revizia {n}, {link}):',
  askPageSectionPrompt:
    'Întrebare despre pagina de cunoștințe „{title}” § {section} (revizia {n}, {link}):',
  pageMissingTitle: 'Această pagină nu este disponibilă.',
  pageMissingBody:
    'Este posibil să fi fost arhivată sau să nu mai aveți acces la cunoștințele acestei companii.',
  pageArchived: 'Arhivată',
  viewingRevisionCurrent: 'Vizualizați revizia {n}; revizia actuală este {current}.',
  viewingRevisionOld: 'Vizualizați revizia {n}. Aceasta nu este revizia actuală.',
  openCurrent: 'Deschide revizia actuală',
  archivedBanner:
    'Această pagină este arhivată. Nu mai informează răspunsurile; istoricul ei este păstrat.',
  pageViewsLabel: 'Vizualizări ale paginii',
  tabRead: 'Citire',
  tabHistory: 'Istoric',
  unknownSection:
    'Secțiunea din link nu face parte din această revizie. Se afișează întreaga pagină.',
  askAboutPage: 'Întreabă despre această pagină',
  exporting: 'Se exportă…',
  exportMarkdown: 'Exportă Markdown',
  loadSuggestionFailed: 'Nu am putut încărca această propunere.',
  evidenceSource: 'Sursă',
  evidenceFact: 'Contextul companiei',
  evidenceResult: 'Lucru salvat',
  evidenceUrl: 'Pagină web',
  evidenceDecision: 'Decizie',
  evidenceReference: 'Referință',
  evidenceOpenPage: 'Deschide pagina de cunoștințe',
  evidenceOpenSource: 'Deschide sursa',
  evidenceOpenFact: 'Deschide contextul companiei',
  evidenceOpenResult: 'Deschide lucrul salvat',
  evidenceOpenUrl: 'Deschide pagina web',
  evidenceOpenDecision: 'Deschide decizia',
  evidenceOpenReference: 'Deschide referința',
  evidenceDecisionNote: 'O decizie înregistrată. Nu există nimic de deschis în Poneva.',
  evidenceFactGone: 'Acest context al companiei nu mai este salvat.',
  evidencePageNoRevision: 'Această pagină nu are nicio revizie aprobată care să poată fi deschisă.',
  evidencePrivateExcerpt: 'Dovadă privată — a fost partajat doar fragmentul de mai sus.',
  evidencePrivate: 'Dovadă privată — conținutul ei nu a fost partajat cu dumneavoastră.',
  evidenceHeading: 'Dovezi',
  evidenceNone: 'Nu au fost atașate dovezi. Evaluați motivul de mai sus în sine.',
  changeAdded: 'Adăugat',
  changeRemoved: 'Eliminat',
  changeChanged: 'Modificat',
  changeUnchanged: 'Nemodificat',
  moreLineCount: 'one:rând suplimentar|few:rânduri suplimentare|other:de rânduri suplimentare',
  moreUnchangedLineCount:
    'one:rând nemodificat suplimentar|few:rânduri nemodificate suplimentare|other:de rânduri nemodificate suplimentare',
  unchangedLineCount: 'one:rând nemodificat|few:rânduri nemodificate|other:de rânduri nemodificate',
  skipAdded: '{lines} — în revizia completă',
  skipRemoved: 'Eliminate: {lines}',
  cutUnchanged: 'Neafișate: {lines}',
  cutChanged: 'Neafișate: {lines} ({changes}). Verificați-le în revizia completă.',
  cutAddedRemoved: 'adăugate: {added}, eliminate: {removed}',
  cutAdded: 'adăugate: {added}',
  cutRemoved: 'eliminate: {removed}',
  lineAddedSr: 'Adăugat:',
  lineRemovedSr: 'Eliminat:',
  noLinesAdded: 'O secțiune nouă. Textul ei se află în revizia completă de mai jos.',
  noLinesRemoved: 'Această secțiune ar fi eliminată din pagină.',
  noLinesChanged: 'Această secțiune se modifică. Textul ei se află în revizia completă de mai jos.',
  diffHeading: 'Modificări',
  outcomeArchived: 'Arhivată.',
  outcomeArchivedBody:
    '{title} nu mai informează răspunsurile și a ieșit din lista de pagini. Reviziile, această propunere și decizia rămân în istoricul paginii.',
  openArchivedPage: 'Deschide pagina arhivată',
  outcomeApproved: 'Aprobată.',
  outcomeApprovedRevision: 'Revizia {n} este acum versiunea aprobată a paginii {title}.',
  outcomeApprovedPlain: 'Această propunere a fost aprobată.',
  outcomeRestored: 'Pagina a revenit în lista de pagini și informează din nou răspunsurile.',
  outcomeKept: 'Propunerea, decizia și fiecare revizie anterioară rămân în istoricul paginii.',
  openPage: 'Deschide pagina',
  outcomeDismissed: 'Respinsă.',
  outcomeWithdrawn: 'Retrasă.',
  outcomeSuperseded: 'Înlocuită.',
  outcomeSupersededBody:
    'O revizie, o propunere sau un import din depozit mai nou a făcut ca această propunere să fie depășită. Ea nu a modificat nimic de la sine.',
  outcomeUnchanged: 'Pagina rămâne neschimbată.',
  approveNewPage: 'Aprobă pagina nouă',
  approveArchive: 'Aprobă arhivarea',
  approveRestoreRevision: 'Restaurează și aprobă revizia {n}',
  approveRevision: 'Aprobă revizia {n}',
  approveArchiveNote:
    'Prin aprobare, această pagină este arhivată pentru toată lumea din {company}.',
  approvePublishNote:
    'Prin aprobare, această revizie este publicată pentru toată lumea din {company}.',
  approvePublishEvidenceNote:
    'Prin aprobare, această revizie și fragmentele de dovezi afișate mai sus sunt publicate pentru toată lumea din {company}.',
  archivedTitle: 'Această pagină este arhivată.',
  alreadyArchivedBody:
    'Aprobarea nu ar schimba nimic, așa că această propunere poate fi doar respinsă.',
  archivedRestoreBody:
    'Aprobarea o restaurează: pagina revine în lista de pagini, în căutare și în răspunsuri cu această revizie.',
  staleRevisionAction: 'Compară cu cea mai recentă versiune',
  staleProposalTitle: 'Această propunere s-a modificat în timp ce o verificați.',
  staleProposalAction: 'Verifică cea mai recentă versiune',
  staleArchivedTitle:
    'Această pagină a fost arhivată în timp ce o verificați. Aprobarea acestei propuneri ar readuce-o.',
  staleArchivedAction: 'Verifică din nou',
  suggestionMissingTitle: 'Această propunere nu este disponibilă.',
  suggestionMissingBody:
    'Este posibil să fi fost retrasă sau să aparțină altcuiva și să nu fi fost trimisă spre verificare în companie.',
  decideUnconfirmed:
    'Nu am putut confirma decizia dumneavoastră. Starea afișată este cea mai recentă primită de la Poneva; verificați-o înainte de a încerca din nou.',
  decideFailed: 'Nu am putut salva decizia dumneavoastră.',
  discussPrompt:
    'Ajută-mă să îmbunătățesc actualizarea de cunoștințe propusă pentru „{title}” ({link}).',
  conflictBody:
    'Această propunere a fost scrisă pe baza reviziei {base}; revizia actuală este {current}. Aprobarea ei ar suprascrie acea modificare, așa că nu poate fi aprobată în forma actuală.',
  conflictBodyPlain:
    'Această propunere a fost scrisă pe baza unei revizii anterioare, așa că nu poate fi aprobată în forma actuală.',
  openLatest: 'Deschide cea mai recentă versiune',
  reworkInChat: 'Reface în chat',
  factReason: 'Motiv',
  factNoReason: 'Nu a fost indicat niciun motiv.',
  factAudience: 'Public',
  factRevision: 'Revizie',
  revisionNew: 'O pagină nouă, revizia 1',
  revisionArchiveAfter: 'Arhivare după revizia {n}',
  revisionWrittenAgainst: 'Scrisă pe baza reviziei {base}; revizia actuală este {current}',
  revisionCurrentToProposed: 'Revizia actuală {base} → revizia propusă {next}',
  revisionProposed: 'Revizia propusă {next}',
  proposedPage: 'Pagina propusă',
  archivingHeading: 'Ce face arhivarea',
  archivingBody:
    'Pagina nu mai informează răspunsurile și iese din lista de pagini. Reviziile ei și această decizie sunt păstrate.',
  noComparison: 'Comparația pe secțiuni nu este disponibilă pentru această propunere.',
  showComplete: 'Afișează revizia completă',
  approving: 'Se aprobă…',
  dismissing: 'Se respinge…',
  dismiss: 'Respinge',
  withdrawing: 'Se retrage…',
  withdraw: 'Retrage',
  editInChat: 'Editează în chat',
  waitingForPublisher: 'Se așteaptă verificarea de către un publicator din companie.',
  snapshotTooLarge: 'Acest snapshot depășește 8 MB. Creați-l cu mai puține documente.',
  snapshotNotSnapshot:
    'Acest fișier nu este un snapshot de cunoștințe. Alegeți fișierul JSON generat de scriptul de snapshot.',
  snapshotEmpty: 'Acest snapshot nu conține niciun document.',
  readDocumentFailed: 'Nu am putut citi acest document. Încercați din nou.',
  readingDocument: 'Se citește documentul…',
  hideText: 'Ascunde textul',
  readText: 'Citește textul',
  textOf: 'Textul documentului {title}',
  gitSnapshot: 'Snapshot Git {commit}',
  repositorySnapshot: 'Snapshot al depozitului',
  importNewHeading: '{pages} · se aprobă la aplicare',
  importNewNote:
    'Fiecare este publicată ca pagină aprobată pentru toată lumea din {company}, fără altă verificare. Citiți-le pe fiecare înainte de a aplica.',
  importChangedHeading: '{pages} · se trimit spre verificare',
  importChangedNote:
    'Fiecare devine o actualizare propusă. Pagina ei se modifică doar când un publicator o aprobă în De verificat, unde se vede ce s-a modificat.',
  unchangedDocumentCount:
    'one:document nemodificat|few:documente nemodificate|other:de documente nemodificate',
  unchangedNote: 'Acestea corespund deja paginilor aprobate. Nu se scrie nimic pentru ele.',
  stagedHeading: 'Pregătit, dar neaplicat',
  excludedSummary: 'Excluse din acest snapshot: {documents}',
  countsLine: '{newPages} · {changedPages} de verificat · nemodificate: {unchanged}',
  importAlreadyDiscarded: 'Acest import a fost deja abandonat.',
  confirmLabel: 'Confirmați importul',
  unchangedKeepCount:
    'one:document nemodificat își păstrează pagina|few:documente nemodificate își păstrează paginile|other:de documente nemodificate își păstrează paginile',
  confirmBody:
    'Aplicați acest import pentru toată lumea din {company}? Se aprobă ca revizia 1: {newPages}. Așteaptă verificarea: {changedPages}. În plus, {unchanged}. Propunerile anterioare de import pentru aceste pagini sunt retrase.',
  applying: 'Se aplică…',
  applyImport: 'Aplică importul',
  chooseAnother: 'Alege alt fișier',
  allCurrent: 'Tot conținutul acestui snapshot este deja actual.',
  importApplied: 'Import aplicat.',
  appliedSummary:
    'Create: {pages} · în așteptarea verificării: {changes} · nemodificate: {unchanged}.',
  appliedIndexing:
    'Paginile noi pot fi căutate în chat după ce se termină indexarea. Pregătirea surselor arată progresul.',
  openPages: 'Deschide paginile',
  reviewChanges: 'Verifică {changes}',
  checkIndexing: 'Verifică progresul indexării',
  sendSnapshotFailed: 'Nu am putut trimite acest snapshot. Încercați din nou.',
  openStagedFailed: 'Nu am putut deschide acest import pregătit.',
  applyUnconfirmed:
    'Nu am putut confirma dacă importul a fost aplicat. Verificați Pagini înainte de a încerca din nou.',
  applyFailed: 'Nu am putut aplica acest import.',
  importHeading: 'Importă pagini din depozit',
  backToPages: 'Înapoi la pagini',
  importLead:
    'Creați un snapshot cu {command}, apoi alegeți fișierul. Veți vedea fiecare document și ce ar modifica înainte să se salveze ceva.',
  snapshotFileLabel: 'Fișier snapshot de cunoștințe',
  readingSnapshot: 'Se citește snapshotul…',
  openingStaged: 'Se deschide importul pregătit…',
  chooseSnapshot: 'Alege fișierul snapshot',
  factOrigin: 'Origine',
  factContents: 'Conținut',
  importOnlyListed: 'Se importă doar documentele enumerate aici.',
  importRepositoryAuthoritative:
    'Depozitul rămâne sursa de referință; documentele modificate devin propuneri de verificat.',
  overviewReviewChanges: 'Verifică modificările',
  overviewConnectAgents: 'Conectează agenți externi',
  overviewEyebrow: 'O înțelegere comună',
  overviewTitle: '{company}, în context.',
  overviewLeadFallback:
    'Cunoștințele companiei dumneavoastră încep cu contextul pe care îl împărtășiți. Construiți împreună o înțelegere a afacerii.',
  overviewBody:
    'Contextul companiei și materialele-sursă îi oferă lui Poneva un punct de plecare — nu tot ce se poate ști despre {company}. Continuați să construiți această înțelegere pe măsură ce afacerea evoluează.',
  overviewAskPrompt: 'Ce știi despre compania noastră și ce ar fi util să adăugăm?',
  overviewAsk: 'Întreabă despre {company}',
  overviewAddSources: 'Adaugă surse',
  contextEyebrow: 'Ce oferă context răspunsurilor',
  contextTitle: 'Afacerea din spatele întrebării.',
  contextBody:
    'Sursele de pe site explică afacerea publică. Notele companiei adaugă terminologia, prioritățile și modul dumneavoastră de lucru.',
  contextPrompt:
    'Ajută-mă să clarific prioritățile companiei și preferințele de lucru pe care ar trebui să le reținem.',
  contextAction: 'Construiește înțelegerea',
  learnEyebrow: 'Loc de învățat',
  learnTitle: 'Începeți cu ce contează în continuare.',
  learnBody:
    'Aduceți materiale-sursă sau clarificați cum lucrează compania. Poneva poate propune modificări durabile pe care să le verificați.',
  learnPrompt:
    'Pe baza cunoștințelor actuale despre compania noastră, ce informații importante lipsesc pentru munca pe care vrem să o facem?',
  learnAction: 'Discută ce ar fi util',
  canvasEmptyTitle: 'Puțin context contează mult.',
  canvasEmptyBody:
    'Profilul companiei este punctul de plecare. Adăugați materiale-sursă și note verificate pentru a-l ajuta pe Poneva să vă înțeleagă munca.',
  pageEyebrow: 'Spațiul de lucru {company}',
  pageTitle: 'Cunoștințele companiei',
  pageDescription: 'Sursele și cunoștințele din spatele muncii lui Poneva.',
  tabOverview: 'Prezentare generală',
  tabPages: 'Pagini',
  tabSources: 'Surse',
  tabReview: 'De verificat',
  proposalApproved: 'Context al companiei aprobat',
  proposalDismissed: 'Propunere respinsă',
  proposalRemoval: 'Eliminare propusă',
  proposalCorrection: 'Corectare propusă',
  proposalContext: 'Context al companiei propus',
  proposalCurrent: 'Înțelegerea actuală',
  proposalFactGone:
    'Faptul salvat nu mai este disponibil. Reîmprospătați cunoștințele companiei înainte de a verifica această eliminare.',
  proposalReviewFallback: 'Verificați contextul propus al companiei.',
  proposalNotSaved: 'Încă nesalvat. Sursele originale rămân neschimbate.',
  proposalWaiting: 'În așteptarea verificării · un publicator decide în Mesaje primite',
  proposalSaving: 'Se salvează…',
  proposalApproveRemoval: 'Aprobă eliminarea',
  proposalApproveClarification: 'Aprobă clarificarea',
  factLabel: 'Fapt despre companie',
  factEyebrow: 'Fapt · Toată lumea din {company}',
  factSuggestCorrection: 'Propune o corectare',
  factAskPrompt:
    'Ajută-mă să înțeleg sau să clarific acest context salvat al companiei: „{content}”',
  factAsk: 'Întreabă despre asta',
  companyContextHeading: 'Contextul companiei',
  companyContextPrompt:
    'Aș vrea să clarific cunoștințele companiei noastre. Ajută-mă să verific ce știm și să propun o actualizare.',
  companyContextEmpty:
    'Nu există încă note aprobate. Începeți o conversație despre compania dumneavoastră sau adăugați materiale-sursă mai jos.',
  refineInChat: 'Rafinează în chat',
  reviewPanelLabel: 'Modificări ale cunoștințelor de verificat',
  suggestedUpdatesHeading: 'Actualizări propuse',
  suggestedUpdatesIntro:
    'Propuneri din conversațiile dumneavoastră. Dumneavoastră decideți ce devine parte din cunoștințele durabile ale companiei.',
  reviewEmptyTitle: 'Nimic nu așteaptă verificarea dumneavoastră.',
  reviewEmptyBody:
    'Când Poneva propune o modificare a cunoștințelor companiei, o veți găsi aici. Modificările durabile au întotdeauna nevoie de aprobarea dumneavoastră.',
  reviewEmptyPrompt:
    'Ajută-mă să verific cunoștințele companiei noastre și propune ce ar fi util să clarificăm în continuare.',
  inclusionPendingApproval: 'Modificarea includerii în cunoștințe a fost trimisă spre aprobare.',
  sourcesFileIncluded:
    'Fișierul a fost inclus în căutarea în cunoștințe pentru publicul său actual.',
  sourcesAddFailed: 'Nu am putut adăuga această sursă.',
  sourcesHeading: 'Materialele din spatele răspunsurilor.',
  sourcesIntro:
    'Poneva caută în toate materialele-sursă, nu doar în prezentarea generală. Păstrați originalele, vedeți ce este pregătit și alegeți ce informează răspunsurile dumneavoastră.',
  addSourceHeading: 'Adăugați materiale din compania dumneavoastră',
  addSourceIntro:
    'Sursele încărcate rămân private în Bibliotecă și informează doar propriile răspunsuri. Alegeți Partajează când sunteți gata să le puneți la dispoziția colegilor.',
  uploadSource: 'Încarcă o sursă',
  addSourcePrompt:
    'Ajută-mă să adaug o declarație a companiei ca sursă internă partajată. Întreabă-mă ce vreau să înregistrez; nu inventa niciun conținut. Modificările durabile ale cunoștințelor companiei au în continuare nevoie de aprobarea mea.',
  addThroughChat: 'Adaugă prin chat',
  addingSource: 'Se adaugă…',
  addToKnowledge: 'Adaugă la cunoștințe',
  uploadFormats: 'TXT, Markdown, CSV și JSON · Până la 5 MB per fișier',
  sourceExcluded: 'Exclusă din răspunsuri',
  sourcePreparationFailed: 'Pregătirea a eșuat',
  sourcePreparing: 'Se pregătește pentru căutare',
  sourceWaiting: 'Așteaptă pregătirea',
  sourceReadinessUnknown: 'Starea de pregătire nu este disponibilă',
  sourceRetryQueued: 'Pregătirea a fost pusă în coadă. Starea se va actualiza după finalizare.',
  sourceIncludedNotice: 'Sursă inclusă. Poneva o va pregăti pentru căutare.',
  sourceExcludedNotice: 'Exclusă din răspunsuri. Sursa originală este păstrată.',
  sourceUpdateFailed: 'Această sursă nu a putut fi actualizată.',
  sourceOriginalMaterial: 'Materialul-sursă original',
  sourceDiscuss: 'Discută în chat',
  sourceDiscussPrompt: 'Ajută-mă să înțeleg sau să clarific „{title}”.',
  sourceExclude: 'Exclude din răspunsuri',
  sourceInclude: 'Include în răspunsuri',
  sourcesLoadFailed: 'Nu am putut încărca sursele dumneavoastră.',
  sourceLibraryLabel: 'Biblioteca de surse a companiei',
  sourceListCaption: 'Surse originale · incluse și excluse',
  sourceSearchLabel: 'Căutați în sursele companiei',
  sourceSearchPlaceholder: 'Căutați în surse…',
  sourcesFinding: 'Se caută sursele…',
  sourcePagesLabel: 'Pagini de surse',
  sourceRange: '{from}–{to} din {count}',
  sourceCount: 'one:sursă|few:surse|other:de surse',
  sourcePrevious: 'Anterioara',
  sourceNext: 'Următoarea',
  sourceNoMatchTitle: 'Nicio sursă corespunzătoare.',
  sourceNoMatchBody: 'Încercați altă expresie sau alt nume de sursă.',
  sourceEmptyTitle: 'Oferiți întrebărilor un punct de plecare mai solid.',
  sourceEmptyBody:
    'Adăugați documente ale companiei, date despre produse sau note de lucru. Poneva poate folosi toate materialele-sursă în conversații și în Skills.',
  indexCheckFailed: 'Nu am putut verifica pregătirea surselor.',
  indexRetryQueued:
    'Intrările de cunoștințe eșuate au fost puse în coadă pentru pregătire. Materialele-sursă nu s-au modificat.',
  indexQueueFailed: 'Nu am putut pune pregătirea în coadă. Încercați din nou.',
  indexPreparing: 'Se pregătesc cunoștințe noi pentru conversațiile dumneavoastră…',
  indexAttention: 'Unele cunoștințe necesită atenție.',
  queuing: 'Se pune în coadă…',
  retryPreparation: 'Reîncearcă pregătirea',
  sourceKindStatement: 'Declarație a companiei',
  sourceKindWebsite: 'Site web',
  sourceKindDocument: 'Document',
  factAnswers: 'one:răspuns|few:răspunsuri|other:de răspunsuri',
  factUsedThisWeek: 'Folosit în {answers} săptămâna aceasta',
  factLastUsed: 'ultima utilizare: {when}',
  factToday: 'astăzi',
  factYesterday: 'ieri',
  factImpact: 'Această modificare afectează un fapt folosit în {answers} săptămâna aceasta.',
  factCorrectionAbout: 'Despre acest fapt al companiei: „{content}” ({link})',
  factCorrectionOutdated: 'Acest lucru nu mai este actual:',
  sourceCanvasRecorded: 'Materiale-sursă înregistrate',
  sourceCanvasNotIncluded:
    'Nu este inclus în cunoștințele companiei. Originalul este păstrat ca referință și poate fi folosit în continuare într-o anumită conversație.',
  sourceCanvasOpenOriginal: 'Deschide sursa originală',
  sourceCanvasUnavailable: 'Conținutul sursei nu este disponibil.',
  sourceCanvasDiscussPrompt: 'Ajută-mă să înțeleg sau să clarific „{title}”.',
  sourceCanvasDiscuss: 'Discută această sursă',
  sourceCanvasCorrectionNote:
    'O corectură devine context al companiei propus. Sursa înregistrată rămâne neschimbată.',
  contextCanvasEyebrow: 'Contextul companiei disponibil',
  contextCanvasTitle: 'Cunoștințele din spatele acestei conversații.',
  contextCanvasBody:
    'Cunoștințe aprobate și materialele-sursă adăugate de compania dumneavoastră. Disponibile în chat și în Skills.',
  contextCanvasOpen: 'Deschide Cunoștințe',
};

export default ro;
